import { AxiosResponse } from 'axios'
import { axiosInstance } from '~/src/config/config_axios'
import { makeQueryUrl } from '~/src/libs'
import {
  INotificationsResponse,
  INotificationResponse,
  IQuery,
  TNotificationBody,
} from './schema/Notification'

export class NotificationRepository {
  /**
   * getNotifications
   * 通知一覧を取得する
   * @param {IQuery} query
   */
  async getNotifications(query: IQuery): Promise<AxiosResponse<INotificationsResponse['data']>> {
    return await axiosInstance.get(makeQueryUrl('/notifications', query))
  }
  /**
   * postNotification
   * @param {TNotificationBody} data
   */
  async postNotification(data: TNotificationBody): Promise<AxiosResponse<INotificationResponse>> {
    return await axiosInstance.post('/notifications', data)
  }
  /**
   * getNotification
   * @param {number} id
   * @param {TNotificationBody} data
   */
  async patchNotification(
    id: number,
    data: TNotificationBody
  ): Promise<AxiosResponse<INotificationResponse>> {
    return await axiosInstance.patch(`/notifications/${id}`, data)
  }

  /**
   * deleteNotification
   * @param {Number} id
   */
  async deleteNotification(id: number): Promise<AxiosResponse<INotificationResponse>> {
    return await axiosInstance.delete(`/notifications/${id}`)
  }
}
